export default __webpack_public_path__ + "static/media/bluetoken.b37997f1.png";